import React, { useState, useEffect } from 'react';
import { db, auth } from '../../firebase';
import { ref, onValue, update } from 'firebase/database';
import { useNavigate } from 'react-router-dom';
// import AccountantLayout from './AccountantLayout';
import { FaSearch, FaFilter, FaMoneyCheckAlt, FaTimes, FaCheckCircle, FaPrint, FaCheck, FaBan } from 'react-icons/fa';

const PaymentDetailModal = ({ isOpen, onClose, data, onStatusUpdate }) => {
    const [isUpdating, setIsUpdating] = useState(false);
    if (!isOpen || !data) return null;

    const handlePrint = () => {
        window.print();
    };

    const handleAction = async (status) => {
        setIsUpdating(true);
        try {
            await onStatusUpdate(data.userId, data.type, status);
            onClose();
        } catch (error) {
            console.error("Error updating status:", error);
            alert("स्थिती अपडेट करताना त्रुटी आली.");
        } finally {
            setIsUpdating(false);
        }
    };

    return (
        <div className="fixed inset-0 z-[100] flex items-center justify-center bg-black/60 backdrop-blur-sm p-4 print:p-0">
            <div className="bg-white rounded-2xl shadow-2xl w-full max-w-lg overflow-hidden animate-in fade-in zoom-in duration-200 print:shadow-none print:rounded-none">
                <div className="bg-gradient-to-r from-blue-600 to-indigo-600 p-5 text-white flex justify-between items-center print:hidden">
                    <div className="flex items-center gap-3">
                        <FaMoneyCheckAlt className="text-xl" />
                        <h3 className="font-bold text-lg">पेमेंट तपशील</h3>
                    </div>
                    <button onClick={onClose} className="hover:bg-white/20 p-2 rounded-full transition-colors">
                        <FaTimes size={18} />
                    </button>
                </div>

                <div className="p-6 space-y-5">
                    <div className="flex justify-center mb-2">
                        <div className={`px-4 py-1.5 rounded-full border flex items-center gap-2 text-sm font-semibold ${
                            data.status === 'accepted' ? 'bg-green-50 text-green-600 border-green-100' :
                            data.status === 'rejected' ? 'bg-red-50 text-red-600 border-red-100' :
                            'bg-amber-50 text-amber-600 border-amber-100'
                        }`}>
                            {data.status === 'accepted' ? <FaCheckCircle /> : data.status === 'rejected' ? <FaBan /> : <FaMoneyCheckAlt />}
                            <span>{data.status === 'accepted' ? 'स्वीकारले' : data.status === 'rejected' ? 'अस्वीकारले' : 'प्रलंबित'}</span>
                        </div>
                    </div>

                    <div className="grid grid-cols-1 gap-4">
                        <div className="flex justify-between items-center py-2 border-b border-gray-50">
                            <span className="text-gray-500 text-sm">नाव/संस्था</span>
                            <span className="text-gray-800 font-semibold text-right">{data.name}</span>
                        </div>
                        <div className="flex justify-between items-center py-2 border-b border-gray-50">
                            <span className="text-gray-500 text-sm">नोंदणी प्रकार</span>
                            <span className="text-gray-800 font-semibold">{data.type}</span>
                        </div>
                        <div className="flex justify-between items-center py-2 border-b border-gray-50">
                            <span className="text-gray-500 text-sm">तालुका</span>
                            <span className="text-gray-800 font-semibold">{data.taluka}</span>
                        </div>
                        <div className="flex justify-between items-center py-2 border-b border-gray-50">
                            <span className="text-gray-500 text-sm">रसीद क्रमांक</span>
                            <span className="text-blue-600 font-bold">{data.receiptId}</span>
                        </div>
                        <div className="flex justify-between items-center py-2 border-b border-gray-50">
                            <span className="text-gray-500 text-sm">UPI ID</span>
                            <span className="text-gray-600 text-xs font-medium">{data.upiId}</span>
                        </div>
                        <div className="flex justify-between items-center py-2 border-b border-gray-50">
                            <span className="text-gray-500 text-sm">पेमेंट रक्कम</span>
                            <span className="text-blue-600 font-bold text-lg">₹{data.amount}/-</span>
                        </div>
                        <div className="flex justify-between items-center py-2">
                            <span className="text-gray-500 text-sm">दिनांक व वेळ</span>
                            <span className="text-gray-800 font-semibold">
                                {new Date(data.paymentDate).toLocaleString('en-GB')}
                            </span>
                        </div>
                    </div>
                </div>

                <div className="p-5 bg-gray-50 flex flex-wrap gap-2 justify-center print:hidden">
                    <button 
                        onClick={handlePrint}
                        className="flex items-center gap-2 bg-blue-600 hover:bg-blue-700 text-white font-semibold px-4 py-2 rounded-lg text-sm transition-all"
                    >
                        <FaPrint /> प्रिंट
                    </button>
                    
                    {data.status !== 'accepted' && (
                        <button 
                            disabled={isUpdating}
                            onClick={() => handleAction('accepted')}
                            className="flex items-center gap-2 bg-green-600 hover:bg-green-700 text-white font-semibold px-4 py-2 rounded-lg text-sm transition-all disabled:opacity-50"
                        >
                            <FaCheck /> स्वीकारा
                        </button>
                    )}

                    {data.status !== 'rejected' && (
                        <button 
                            disabled={isUpdating}
                            onClick={() => handleAction('rejected')}
                            className="flex items-center gap-2 bg-red-600 hover:bg-red-700 text-white font-semibold px-4 py-2 rounded-lg text-sm transition-all disabled:opacity-50"
                        >
                            <FaBan /> नाकारा
                        </button>
                    )}

                    <button 
                        onClick={onClose}
                        className="bg-white border border-gray-200 text-gray-600 hover:bg-gray-50 font-semibold px-4 py-2 rounded-lg text-sm transition-all"
                    >
                        बंद करा
                    </button>
                </div>
            </div>
        </div>
    );
};

const AccountantFeeChallanList = () => {
    const [challans, setChallans] = useState([]);
    const [loading, setLoading] = useState(true);
    const [searchTerm, setSearchTerm] = useState('');
    const [selectedType, setSelectedType] = useState('');
    const [selectedPayment, setSelectedPayment] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        const unsubscribe = auth.onAuthStateChanged((user) => {
            if (!user) navigate('/login');
        });

        const engineerRef = ref(db, 'ekamwatapzp/EngineerRegistrations');
        const societyRef = ref(db, 'ekamwatapzp/SocietyRegistrations');

        let engSync = false;
        let socSync = false;
        let engData = [];
        let socData = [];

        const processResults = () => {
            if (engSync && socSync) {
                const combined = [...engData, ...socData].sort((a, b) => 
                    new Date(b.paymentDate) - new Date(a.paymentDate)
                );
                setChallans(combined);
                setLoading(false);
            }
        };

        const fetchChallans = () => {
            onValue(engineerRef, (snapshot) => {
                engData = [];
                if (snapshot.exists()) {
                    const data = snapshot.val();
                    Object.keys(data).forEach(key => {
                        const user = data[key];
                        if (user.statusPaymentStatus === 'paid' && user.payments?.['Registration status invoice']) {
                            const inv = user.payments['Registration status invoice'];
                            engData.push({
                                userId: key,
                                name: `${user.firstName} ${user.surname}`,
                                type: 'सु.वे. अभियंता',
                                taluka: user.taluka,
                                amount: inv.paidAmount,
                                receiptId: inv.receiptId,
                                paymentDate: inv.date,
                                upiId: inv.userUpiId,
                                status: inv.accountantStatus || 'pending'
                            });
                        }
                    });
                }
                engSync = true;
                processResults();
            });

            onValue(societyRef, (snapshot) => {
                socData = [];
                if (snapshot.exists()) {
                    const data = snapshot.val();
                    Object.keys(data).forEach(key => {
                        const user = data[key];
                        if (user.statusPaymentStatus === 'paid' && user.payments?.['Registration status invoice']) {
                            const inv = user.payments['Registration status invoice'];
                            socData.push({
                                userId: key,
                                name: user.societyName,
                                type: 'मजूर सहकारी संस्था',
                                taluka: user.taluka,
                                amount: inv.paidAmount,
                                receiptId: inv.receiptId,
                                paymentDate: inv.date,
                                upiId: inv.userUpiId,
                                status: inv.accountantStatus || 'pending'
                            });
                        }
                    });
                }
                socSync = true;
                processResults();
            });
        };

        fetchChallans();
        return () => unsubscribe();
    }, [navigate]);

    const handleStatusUpdate = async (userId, userType, status) => {
        const node = userType === 'सु.वे. अभियंता' ? 'EngineerRegistrations' : 'SocietyRegistrations';
        const invoiceKey = 'Registration status invoice';
        
        try {
            await update(ref(db, `ekamwatapzp/${node}/${userId}/payments/${invoiceKey}`), {
                accountantStatus: status,
                accountantActionDate: new Date().toISOString()
            });
            alert(`पेमेंट ${status === 'accepted' ? 'स्वीकारले' : 'अस्वीकारले'} गेले आहे.`);
        } catch (error) {
            console.error("Error updating status:", error);
            throw error;
        }
    };

    const filteredData = challans.filter(item => {
        const matchesSearch = item.name.toLowerCase().includes(searchTerm.toLowerCase()) || 
                             item.receiptId.toLowerCase().includes(searchTerm.toLowerCase());
        const matchesType = selectedType === '' || item.type === selectedType;
        return matchesSearch && matchesType;
    });

    if (loading) {
        return (
            <div className="min-h-screen flex items-center justify-center bg-gray-50">
                <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-blue-600"></div>
            </div>
        );
    }

    return (
        <div className="min-h-screen bg-[#f4f7fa] p-4 md:p-8">
            <div className="mb-8 flex flex-col md:flex-row md:items-center justify-between gap-4">
                <div>
                    <h1 className="text-2xl font-bold text-gray-800 tracking-tight flex items-center gap-3">
                        <FaMoneyCheckAlt className="text-blue-600" />
                        फी चलन यादी (Fee Challans - ₹5000)
                    </h1>
                    <p className="text-gray-500 font-semibold mt-1 text-sm uppercase tracking-wider">एकूण प्राप्त पेमेंट: {filteredData.length}</p>
                </div>
            </div>

            <div className="bg-white p-6 rounded-2xl shadow-sm border border-gray-100 mb-8 flex flex-col md:flex-row gap-4 items-center">
                <div className="flex-grow relative w-full">
                    <FaSearch className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-400 text-sm" />
                    <input 
                        type="text" 
                        placeholder="नाव किंवा रसीद क्रमांक शोध..." 
                        className="w-full pl-12 pr-4 py-3 rounded-xl border border-gray-100 bg-gray-50 focus:ring-2 focus:ring-blue-500/20 focus:border-blue-500 outline-none transition-all font-semibold"
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                    />
                </div>
                <div className="flex items-center space-x-3 w-full md:w-auto">
                    <FaFilter className="text-blue-600" />
                    <select 
                        className="bg-gray-50 border border-gray-100 rounded-xl px-4 py-3 outline-none focus:ring-2 focus:ring-blue-500/20 focus:border-blue-500 font-semibold text-gray-600 w-full"
                        value={selectedType}
                        onChange={(e) => setSelectedType(e.target.value)}
                    >
                        <option value="">सर्व प्रकार</option>
                        <option value="सु.वे. अभियंता">सु.वे. अभियंता</option>
                        <option value="मजूर सहकारी संस्था">मजूर सहकारी संस्था</option>
                    </select>
                </div>
            </div>

            <div className="bg-white rounded-2xl shadow-sm border border-gray-100 overflow-hidden">
                <div className="overflow-x-auto">
                    <table className="w-full text-left">
                        <thead className="bg-gray-50/50">
                            <tr>
                                <th className="px-6 py-4 text-xs font-bold uppercase tracking-wider text-gray-500 text-center w-16">#</th>
                                <th className="px-6 py-4 text-xs font-bold uppercase tracking-wider text-gray-500">नाव/संस्था</th>
                                <th className="px-6 py-4 text-xs font-bold uppercase tracking-wider text-gray-500">प्रकार</th>
                                <th className="px-6 py-4 text-xs font-bold uppercase tracking-wider text-gray-500">तालुका</th>
                                <th className="px-6 py-4 text-xs font-bold uppercase tracking-wider text-gray-500">रसीद क्र.</th>
                                <th className="px-6 py-4 text-xs font-bold uppercase tracking-wider text-gray-500">रक्कम</th>
                                <th className="px-6 py-4 text-xs font-bold uppercase tracking-wider text-gray-500 text-center">स्थिती</th>
                                <th className="px-6 py-4 text-xs font-bold uppercase tracking-wider text-gray-500 text-center">तपशील</th>
                            </tr>
                        </thead>
                        <tbody className="divide-y divide-gray-50">
                            {filteredData.map((item, index) => (
                                <tr key={item.userId} className="hover:bg-gray-50/50 transition-colors">
                                    <td className="px-6 py-4 text-center text-sm font-semibold text-gray-400">{index + 1}</td>
                                    <td className="px-6 py-4">
                                        <div className="text-gray-900 font-semibold">{item.name}</div>
                                        <div className="text-[10px] text-gray-400 font-medium">{item.upiId}</div>
                                    </td>
                                    <td className="px-6 py-4">
                                        <span className={`text-[10px] font-bold px-2 py-1 rounded-lg ${
                                            item.type === 'सु.वे. अभियंता' ? 'bg-blue-50 text-blue-600' : 'bg-amber-50 text-amber-600'
                                        }`}>
                                            {item.type}
                                        </span>
                                    </td>
                                    <td className="px-6 py-4 text-sm font-semibold text-gray-600">{item.taluka}</td>
                                    <td className="px-6 py-4 text-sm font-bold text-gray-500">{item.receiptId}</td>
                                    <td className="px-6 py-4 text-sm font-bold text-blue-600">₹{item.amount}/-</td>
                                    <td className="px-6 py-4 text-center">
                                        <span className={`px-3 py-1 rounded-full text-[10px] font-bold border ${
                                            item.status === 'accepted' ? 'bg-green-50 text-green-600 border-green-100' :
                                            item.status === 'rejected' ? 'bg-red-50 text-red-600 border-red-100' :
                                            'bg-amber-50 text-amber-600 border-amber-100'
                                        }`}>
                                            {item.status === 'accepted' ? 'स्वीकारले' : item.status === 'rejected' ? 'अस्वीकारले' : 'प्रलंबित'}
                                        </span>
                                    </td>
                                    <td className="px-6 py-4 text-center">
                                        <button 
                                            onClick={() => {
                                                setSelectedPayment(item);
                                                setIsModalOpen(true);
                                            }}
                                            className="bg-blue-600 hover:bg-blue-700 text-white text-[10px] font-bold px-4 py-2 rounded-xl transition-all shadow-md shadow-blue-100 active:scale-95"
                                        >
                                            तपशील
                                        </button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>

            <PaymentDetailModal 
                isOpen={isModalOpen} 
                onClose={() => setIsModalOpen(false)} 
                data={selectedPayment} 
                onStatusUpdate={handleStatusUpdate}
            />
        </div>
    );
};

export default AccountantFeeChallanList;
